import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { UnableToLoginComponent } from './unable-to-login/unable-to-login.component';
import { Routes, RouterModule } from '@angular/router';
import { MDBBootstrapModulesPro, CardsModule, InputsModule, WavesModule, ButtonsModule } from 'ng-uikit-pro-standard';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { authReducer } from 'src/app/_store/reducers/auth.reducers';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from 'src/app/_store/effects/auth.effects';
import { RegisterComponent } from './register/register.component';
import { SuccessfullyRegisterComponent } from './successfully-register/successfully-register.component';
import { ResetPasswordModule } from 'projects/cpa/src/app/pages/modal-pages/reset-password/reset-password.module';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LottieCacheModule, LottieModule } from 'ngx-lottie';
import { NgSelectModule } from '@ng-select/ng-select';
import { StepsComponent } from './steps/steps.component';
import { OnBoardingLoaderComponent } from './on-boarding-loader/on-boarding-loader.component';
import { LmsLoginComponent } from './lms-login/lms-login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CanavasComponent } from './canavas/canavas.component';
export function playerFactory() {
  return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');
}

const routes: Routes = [
  // { path: '', component: LoginComponent },
  { path: 'godfather-start-page', component: ForgotPasswordComponent },
  { path: 'game-plan-status-page', component: StepsComponent },
  { path: 'unable-to-login', component: ResetPasswordComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'successfully-register', component: SuccessfullyRegisterComponent },
  { path: 'godfather-last-page', component: OnBoardingLoaderComponent },
  { path: '', component: LmsLoginComponent },
  { path: 'canvas', component: CanavasComponent },
  // { path: 'forgot-password', component: ResetPasswordComponent }

];


@NgModule({
  declarations: [LoginComponent,
    ForgotPasswordComponent,
    UnableToLoginComponent,
    RegisterComponent,
    SuccessfullyRegisterComponent,
    StepsComponent,
    OnBoardingLoaderComponent,
    LmsLoginComponent,
    ResetPasswordComponent],
  imports: [
    CommonModule, ReactiveFormsModule, ResetPasswordModule,
    MDBBootstrapModulesPro.forRoot(),
    CardsModule, FormsModule, InputsModule, WavesModule, ButtonsModule, NgxCaptchaModule,
    RouterModule.forChild(routes),
    LottieCacheModule,
    LottieModule.forRoot({ player: playerFactory }),
    // NgParticlesModule,
    NgSelectModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects])
  ],
  providers: [DecimalPipe],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule { }
